import { render, staticRenderFns } from "./FormDocumentos.vue?vue&type=template&id=76a2f37e&scoped=true&"
import script from "./FormDocumentos.vue?vue&type=script&lang=js&"
export * from "./FormDocumentos.vue?vue&type=script&lang=js&"
import style0 from "./FormDocumentos.vue?vue&type=style&index=0&id=76a2f37e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a2f37e",
  null
  
)

export default component.exports